export default __webpack_public_path__ + "static/media/delete.5d699c0e.svg";